import { SolarModule } from './solar/solar.module';
import { SharedModule } from './shared/shared.module';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, APP_INITIALIZER } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { CoreModule } from './core/core.module';
import { environment } from '../environments/environment';

import { SimpleNotificationsModule } from 'angular2-notifications';
import { DynamicComponentManifest } from 'app/common/dynamic-component-loader/dynamic-component-manifest';
import { DynamicComponentLoaderModule } from 'app/common/dynamic-component-loader/dynamic-component-loader.module';

export function fetchTranslations() {
    const api = environment.config.server.sahara + '/api/translation/dictionary';
    return () => fetch(api, {}).then(parseResponse);
}
function parseResponse(res: any) {
    return res.json().then(resp => {
        window['translations'] = resp.data;
    });
}

const manifests: DynamicComponentManifest[] = [
    {
        componentId: 'reviewDetailsComponent',
        path: 'review/details/:id',
        loadChildren: './common/reviews/reviews.module#ReviewsModule'
    },
    {
        componentId: 'productsCommonComponent',
        path: 'products',
        loadChildren: './common/product-data/products/products-common.module#ProductsCommonModule'
    },
    {
        componentId: 'productDetailsCommonComponent',
        path: 'products/details/:id',
        loadChildren:
            './common/product-data/products/components/details/product-details-common.module#ProductDetailsCommonModule'
    },
    {
        componentId: 'productBulkEditCommonComponent',
        path: 'products/bulk-edit',
        loadChildren:
            './common/product-data/products/components/bulk-edit/product-bulk-edit-common.module#ProductBulkEditCommonComponent'
    },
    {
        componentId: 'productVariantDetailsCommonComponent',
        path: 'product-variants/:id/details',
        loadChildren:
            './common/product-data/product-variants/components/details/product-variant-details-common.module#ProductVariantDetailsCommonModule'
    },
    {
        componentId: 'courseMainCommonComponent',
        path: 'courses',
        loadChildren:
            './common/courses/courses.module#CoursesCommonModule'
    },
    {
        componentId: 'courseCreateStepperComponent',
        path: 'courses/:id/create',
        loadChildren:
            './common/courses/courses.module#CoursesCommonModule'
    },
    {
        componentId: 'courseCompleteDetailsComponent',
        path: 'courses/:id/details',
        loadChildren:
            './common/courses/courses.module#CoursesCommonModule'
    },
    {
        componentId: 'courseEditComponent',
        path: 'courses/:id/edit',
        loadChildren:
            './common/courses/courses.module#CoursesCommonModule'
    },
    {
        componentId: 'courseCreateComponent',
        path: 'courses/create',
        loadChildren:
            './common/courses/courses.module#CoursesCommonModule'
    }
];

@NgModule({
    declarations: [
        AppComponent,
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        HttpModule,
        AppRoutingModule,
        CoreModule,
        SharedModule,
        SolarModule,
        SimpleNotificationsModule.forRoot(),
        DynamicComponentLoaderModule.forRoot(manifests)
    ],
    providers: [
        {
            provide: APP_INITIALIZER,
            useFactory: fetchTranslations,
            deps: [],
            multi: true
        }
    ],
    bootstrap: [AppComponent]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts